import React, { useEffect, useRef, useState } from "react";

import ReactPlayer from "react-player";

import useOnScreen from "../../Helpers/isInView";

const VideoTwo = ({ Rocket }) => {
  const [playing, setPlaying] = useState(false);

  const ref = useRef();
  const isVisible = useOnScreen(ref);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        setPlaying(true);
      }, 200);
    }
  }, [isVisible]);

  return (
      <>
          {Rocket ? (
              <div className="video" ref={ref}>
        <div className="videoTwo">
      <ReactPlayer
        playing={playing}
        width="100%"
        height="100%"
        muted={true}
        url={[{ src: Rocket }]}
        config={{
          file: {
            forceDash: true,
          },
        }}
      />
        </div>
    </div>) : (<div className="videoThree" ref={ref}></div>)}</>
  );
};

export default VideoTwo;
